// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ni[data-v-0c81d9a0]:hover {\r\n  cursor: pointer\n}\nel-button[data-v-0c81d9a0] {\n}\r\n", ""]);
// Exports
module.exports = exports;
